import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { PenaltyAdditonal } from 'src/app/core/models/cancellation-overrides.model';
import { OpenTicketService } from 'src/app/open-ticket/services/open-ticket.service';
import { TicketHistoryService } from 'src/app/search-result/services/ticket-history.service';

@Component({
  selector: 'app-farebasis-per-passenger',
  templateUrl: './farebasis-per-passenger.component.html',
})
export class FarebasisPerPassengerComponent {

  @Input() farebasis: PenaltyAdditonal;
  KEYWORDS= [ 'NO SHOW', 'CHANGES'];

  highlight(categoryText: string) {
    this.KEYWORDS.forEach(key => {
      categoryText = categoryText.replace(
        new RegExp(key, 'gi'),
        match => '<span class="has-background-yellow"> ' + match + ' </span>'
      );
    });
    return categoryText;
  }

}
